import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { SelectedClientProvider } from "./contexts/SelectedClientContext";
import { TimerProvider } from "./contexts/TimerContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Layout } from "./components/layout/Layout";
import "@/App.css";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import OnboardingPage from "./pages/OnboardingPage";
import PaywallPage from "./pages/PaywallPage";
import DashboardPage from "./pages/DashboardPage";
import ClientsPage from "./pages/ClientsPage";
import ClientWorkspacePage from "./pages/ClientWorkspacePage";
import AllTasksPage from "./pages/AllTasksPage";
import AllInvoicesPage from "./pages/AllInvoicesPage";
import TimeTrackerPage from "./pages/TimeTrackerPage";
import LeadsPage from "./pages/LeadsPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import QuoteDetailPage from "./pages/QuoteDetailPage";
import InvoiceDetailPage from "./pages/InvoiceDetailPage";
import RecurringInvoicesPage from "./pages/RecurringInvoicesPage";
import CalendarPage from "./pages/CalendarPage";
import AdminPage from "./pages/AdminPage";
import AffiliatesPage from "./pages/AffiliatesPage";
import FinancialsPage from "./pages/FinancialsPage";
import BudgetPlannerPage from "./pages/BudgetPlannerPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import TrainingPage from "./pages/TrainingPage";
import SavingsTrackerPage from "./pages/SavingsTrackerPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SelectedClientProvider>
          <TimerProvider>
            <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route path="/paywall" element={<PaywallPage />} />

              {/* Protected Routes */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="clients" element={<ClientsPage />} />
                <Route path="clients/:clientId" element={<ClientWorkspacePage />} />
                <Route path="tasks" element={<AllTasksPage />} />
                <Route path="invoices" element={<AllInvoicesPage />} />
                <Route path="invoices/:invoiceId" element={<InvoiceDetailPage />} />
                <Route path="quotes/:quoteId" element={<QuoteDetailPage />} />
                <Route path="recurring" element={<RecurringInvoicesPage />} />
                <Route path="calendar" element={<CalendarPage />} />
                <Route path="time" element={<TimeTrackerPage />} />
                <Route path="leads" element={<LeadsPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="financials" element={<FinancialsPage />} />
                <Route path="budget" element={<BudgetPlannerPage />} />
                <Route path="analytics" element={<AnalyticsPage />} />
                <Route path="savings" element={<SavingsTrackerPage />} />
                <Route path="training" element={<TrainingPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="admin" element={<AdminPage />} />
                <Route path="admin/affiliates" element={<AffiliatesPage />} />
              </Route>

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
          </TimerProvider>
        </SelectedClientProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
